export interface IPropertySite {
    landUse: string;
    countyUse: string;
    stateUse: string;
    zoning: string;
    numberOfBuildings: number;
    UnitsResidential: number;
    UnitsCommercial: number
    InsideSfha: string;
}

export class PropertySite implements IPropertySite {
    public landUse: string;
    public countyUse: string;
    public stateUse: string;
    public zoning: string;
    public numberOfBuildings: number;
    public UnitsResidential: number;
    public UnitsCommercial: number
    public InsideSfha: string;
}